import { Injectable } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';

import { AuthenticatedHttpService } from './authenticatedhttp.service';
import { CurrentUserService } from './current-user.service';

import { QuoteRevision } from '../model/quote-revision';
import { QuoteRevisionAggregate } from '../model/quote-revision-aggregate';

@Injectable()
export class QuoteRevisionService {
  private baseUrl;

  constructor(
    private _http: AuthenticatedHttpService,
    private currentUserService: CurrentUserService
  ) {
    this.baseUrl = _http.getBaseURLFromCookie();
  }

	getQuoteRevisionsByQuote(quoteId: number): Observable<QuoteRevision[]> {
		return this._http
			.get(`${this.baseUrl}/api/quoterevision/${quoteId}`)
			.map(x => {
				let returnQuoteRevision = new Array<QuoteRevision>();
				returnQuoteRevision = x.json();
				return returnQuoteRevision;
			})
			.catch((error: any) => Observable.throw(error.json().error));
	}

	getQuoteRevisionsByRevisionNumber(quoteId: number, revisionNumber: number): Observable<QuoteRevision> {
		return this._http
			.get(`${this.baseUrl}/api/quoterevision/${quoteId}/${revisionNumber}`)
			.map(x => {
				let returnQuoteRevision = new QuoteRevision();
				returnQuoteRevision = x.json();
				return returnQuoteRevision;
			})
			.catch((error: any) => Observable.throw(error.json().error));
	}

	insertQuoteRevision(quoteRevision: QuoteRevision): Observable<QuoteRevision> {
		return this._http
			.post(this.baseUrl + '/api/quoterevision/', JSON.stringify(quoteRevision))
			.map(x => {
				let returnQuoteRevision = new QuoteRevision();
				returnQuoteRevision = x.json();
				return returnQuoteRevision;
			})
			.catch((error: any) => Observable.throw(error.json().error));
	}

	UpdateQuoteRevision(quoteRevision: QuoteRevision): Observable<QuoteRevision> {
		return this._http
			.put(this.baseUrl + '/api/quoterevision/', JSON.stringify(quoteRevision))
			.map(x => {
				let returnQuoteRevision = new QuoteRevision();
				returnQuoteRevision = x.json();
				return returnQuoteRevision;
			})
			.catch((error: any) => Observable.throw(error.json().error));
	}

	/// Gets multiple quote revisions data
	getQuoteRevisionAggregates(quoteId: number, revisionNumbers: number[]) {
		const firstData = this.getQuoteRevisionAggregate(quoteId, revisionNumbers[0]);
		const secondData = this.getQuoteRevisionAggregate(quoteId, revisionNumbers[1] );
		return combineLatest(firstData, secondData);
	}

	getQuoteRevisionAggregate(quoteId: number, revisionNumber: number ): Observable<QuoteRevisionAggregate[]> {
		return this._http
			.get(`${this.baseUrl}/api/quotes/${quoteId}/${revisionNumber}/revisionaggregate`)
			.map(x => {
				return x.json();
			})
			.catch((error: any) => Observable.throw(error.json().error));
	}
	
	/// Restores previous version of a quote
	rollbackRevision(quoteId: number, revisionNumber: number) {
		return this._http.get(`${this.baseUrl}/api/quotes/${quoteId}/${revisionNumber}/rollback`);
	}
	
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/quote-revision.service.ts